import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// style components
import { Container, StatusTogglesWrapper, StatusToggle } from './StatusSelect.styled';

// constants
import { getStatuses } from '../../constants/statuses.order.const';

const StatusSelect = ({orderId, status, onStatusChange}) => {
  const { t } = useTranslation();
  const statuses = getStatuses(t);

  const handleStatusChange = (newStatus) => {
    if (status !== newStatus) {
      onStatusChange(orderId, newStatus);
    }
  };

  return (
    <Container>
      <StatusTogglesWrapper>
        {statuses.map((statusOption) => (
          <StatusToggle
            key={statusOption.value}
            active={status === statusOption.value}
            onClick={() => handleStatusChange(statusOption.value)}
            type="button"
          >
            {statusOption.label}
          </StatusToggle>
        ))}
      </StatusTogglesWrapper>
    </Container>
  );
};

StatusSelect.propTypes = {
  orderId: PropTypes.string,
  status: PropTypes.number,
  onStatusChange: PropTypes.func,
};

export default StatusSelect;
